import React, { useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@material-ui/core";
import {AiFillFilePdf} from 'react-icons/ai'
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

const rows = [
  { slNo: 1, description: "Circular mandating online submission of Applications", date: '10-Dec-2020', pdfUrl: "6707df67-0960-4231-a01e-dda719d885a7" },
]

const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const AdminstrativeOrders = () => {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return (
    <React.Fragment>
    <TableContainer component={Paper}>
    <Typography variant='h6' style={{margin: '20px'}}>
      AdminstrativeOrders
    </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableHead>
          <TableRow style={{background: '#1F4A7C', height: '20px'}}>
            <TableCell style={{width: '5%', color: 'white'}}>SL. No</TableCell>
            <TableCell style={{width: '60%', color: 'white'}}>Headline</TableCell>
            <TableCell style={{width: '10%', color: 'white'}}>Notification Date</TableCell>
            <TableCell style={{width: '5%', color: 'white'}}>Download</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.slNo}>
              <TableCell component="th" scope="row">
                {row.slNo}
              </TableCell>
              <TableCell>{row.description}</TableCell>
              <TableCell>{row.date}</TableCell>
              <TableCell onClick={() => getDocumentByFileStoreId(row.pdfUrl, setIsPreviewLoading)}><AiFillFilePdf style={{width: '30px', height: '30px', color:'#f44b55', cursor: 'pointer' }}/></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </React.Fragment>
  );
};

export default AdminstrativeOrders;
